import { useEffect, useState, version } from "react";
import SidebarManager from "../components/SidebarManager.js";
import Header from "../components/Header.js";
import NumCard from "../components/NumCard.js";
import CreateCompanyProfile from "../components/CreateCompanyProfile.js";
import Table from "../components/Table.js";
import { useNavigate, useLocation } from "react-router-dom";
import StatsCards from "../components/StatsCards.js";
import { getAllUsers } from "../services/authServices.js";
import { useAuth } from "../context/AuthContext.js";
import {
  getCompanyDetailsById,
  assignCompanyToValidator,
} from "../services/companyService.js";
import { useModal } from "../context/ModalContext.js";

function AssignForms() {
  const [loading, setLoading] = useState(true);
  let [company, setCompany] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const companyId = parseInt(query.get("companyId")) || 0;
  const { showModal } = useModal();

  const [stats, setStats] = useState({
    totalCompanies: 0,
    listedCompanies: 0,
    totalForms: 0,
    approvedForms: 0,
    pendingForms: 0,
    rejectedForms: 0,
  });

  const [validators, setValidators] = useState([]);

  const fetchValidators = async (selectedCompany) => {
    try {
      setLoading(true);
      if (
        selectedCompany &&
        selectedCompany?.assignedValidators &&
        selectedCompany?.assignedValidators.length > 0
      ) {
        const assignedValidators = selectedCompany.assignedValidators.map(
          (x) => x.userId
        );
        let response = await getAllUsers(3, null, assignedValidators);
        // response = response.filter((x) => !assignedValidators.includes(x.id));
        setValidators(response);
      } else {
        let response = await getAllUsers([3, null, [user.Id]]);
        setValidators(response);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to load company data:", error);
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await fetch("/api/dashboard-stats");
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error("Failed to fetch stats:", error);
    }
  };

  const getCompanyDetails = async () => {
    try {
      await getCompanyDetailsById(companyId).then(async (response) => {
        // console.log(response);
        setCompany(response);
        if (response.id) {
          await fetchValidators(response);
        }
      });
    } catch (error) {
      console.error("Failed to fetch stats:", error);
    }
  };

  const assignCompany = async (selectedUser) => {
    try {
      if (selectedUser && company) {
        // console.log(selectedUser);
        const payload = {
          companyId: company.companyId,
          version: company.version,
          validatorId: selectedUser.id,
        };
        const response = await assignCompanyToValidator(payload);
        if (response.status) {
          showModal(
            "Assigned Successfully",
            `${company.registeredName}       ${selectedUser.displayName}`
          );
          navigate("/company-profile");
        } else {
          showModal(
            "Assigned Failed!",
            `${company.registeredName}       ${selectedUser.displayName}`
          );
        }
      }
    } catch (error) {
      console.error("Failed to fetch stats:", error);
      showModal("Assigned Failed!", `${error}`);
    }
  };

  useEffect(() => {
    getCompanyDetails();
    // fetchStats(); // Uncomment when API is ready
  }, []);

  const redirectToForm = (row) => {
    //navigate(`/form?companyId=${row.id}`);
  };

  const today = new Date().toLocaleDateString("en-GB", {
    weekday: "long",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const columns = [
    { label: "Name", key: "displayName" },
    { label: "Email", key: "email", align: "start" },
    { label: "Contact Number", key: "contactNumber", align: "start" },
    {
      label: "Action",
      key: "action",
      align: "center",
      render: (row) => (
        <button
          className="bg-[#6f81f5] text-white px-4 py-1 rounded-lg text-sm hover:opacity-90 cursor-pointer"
          onClick={() => assignCompany(row)}
        >
          Assign
        </button>
      ),
    },
  ];

  const statistitcs = [
    {
      label: "Total Forms",
      value: 200,
      color: "text-indigo-500",
      border: "border-indigo-300",
    },
    {
      label: "Approved Forms",
      value: 50,
      color: "text-green-600",
      border: "border-green-300",
    },
    {
      label: "Pending Forms",
      value: 30,
      color: "text-yellow-500",
      border: "border-yellow-300",
    },
    {
      label: "Rejected Forms",
      value: 20,
      color: "text-red-500",
      border: "border-red-300",
    },
  ];

  return (
    <div className="py-8 px-[5rem] bg-[#fbfbfb] w-screen mx-auto">
      <Header title="Assign Forms" date={today} />

      <div className="p-6 bg-gray-50">
        <StatsCards stats={statistitcs} />
      </div>

      {/* Company Table Section */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Validators</h2>
        <p className="text-sm mb-4 text-gray-500">
          Total: {validators.length} Numbers
        </p>
        <Table
          columns={columns}
          rows={validators}
          colour="#c5cdfb"
          loading={loading}
        />
      </div>
    </div>
  );
}

export default AssignForms;
